export const extractErrorMessage = (error: unknown) => {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error.message;
  }

  return 'Unknown error';
};
